<template>
    <el-config-provider :locale="zhCn">
        <div id="app">
            <layout />
        </div>
    </el-config-provider>
</template>

<script>
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import to from '@bilibili/magic-bag/awaitTo';
import layout from '@/layout';
import useCommonStore from '@/common/store/common';
import { merchantInfo } from '@/common/services';
import isIframe from '@bilibili/magic-bag/isIframe';
import { cookies } from '@bilibili/magic-bag';
import { getQuery } from '@bilibili/magic-bag/url';
import { ClientFromEnum } from '@/common/types/types';

export default {
    components: {
        layout
    },
    data() {
        return {
            zhCn
        };
    },
    async created() {
        const clientFrom = getQuery(window.location.hash).clientFrom;
        const sourceType = getQuery(window.location.hash).source_type;
        const commonStore = useCommonStore();
        const merchantId = cookies.get('BILI-MALL-MERCHANT-ID') || '';
        const [err, data] = await to(merchantInfo());
        if (!err) {
            commonStore.setUserInfo(data);
            data && this.$replay.setUserInfo(merchantId, data.uid);
        }
        if (![ClientFromEnum.TICKET, ClientFromEnum.UP].includes(clientFrom) && !['award', 'gf'].includes(sourceType)) {
            commonStore.initMerchantAccountInfo();
            commonStore.setCustomInfo();
        }
        commonStore.setDefaultTrackConfig();
    },
    mounted() {
        if (!isIframe) {
            document.body.style.background = 'linear-gradient(135deg,#e9f1fc 51.6%,#fdeaef)';
        }
    }
};
</script>
